"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FeatureCollection {
}
exports.FeatureCollection = FeatureCollection;
class Features {
}
exports.Features = Features;
class Geometry {
}
exports.Geometry = Geometry;
